
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12630',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12630",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9756",
  "foundations-components": "static-1.8115",
  "foundations-components-legacy": "static-1.1140",
  "foundations-theming": "static-1.4527",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8113",
  "hub-http-shared-msw-handlers": "static-1.10189",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11569",
  "I18n": "static-7.1634",
  "jasmine-runner": "static-1.6555",
  "marketplace-storefront-base": "static-1.12693",
  "quartz": "static-1.7145",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16777",
  "reactive-variable-buffer-atom": "static-1.2953",
  "reporting-testing-lib": "static-1.9854",
  "settings-ui-lib": "static-1.12615",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7308",
  "ui-addon-i18n": "static-1.11245",
  "ui-addon-react-router-dom": "static-1.9634",
  "unified-auth": "static-1.603",
  "unified-auth-core-lib": "static-1.885",
  "usage-tracker": "static-1.7442",
  "usage-tracker-core": "static-1.7292",
  "customer-data-property-utils": "static-1.8191",
  "hub-http": "static-1.6316",
  "integrations-lib": "static-1.16456",
  "marketplace-ui-common": "static-1.20087",
  "property-management-iframe": "static-1.13478",
  "quartz-config": "static-1.923",
  "quartz-core": "static-1.6364",
  "quartz-routing": "static-1.575",
  "quick-fetch": "static-1.3986",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4750",
  "ts-schema": "static-1.4149",
  "ui-universal-auth": "static-1.9089",
  "UIComponents": "static-3.8515",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3468",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3422",
  "quartz-webpack": "static-1.3369",
  "bend-plugin-quartz-routing": "static-1.223",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4384",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4964",
  "foundations-theming-specialty": "static-1.2243",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9516",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5411",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2165",
  "ui-fonts": "static-1.831",
  "ui-images": "static-2.1175",
  "bend-plugin-foundations-theming": "static-1.3010",
  "foundations-theming-base": "static-1.3512",
  "stylex": "static-1.34",
  "HeadJS": "static-2.766",
  "hs-test-utils-bend-plugin": "static-1.3224",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4421",
  "ai-components-ui-library": "static-1.9187",
  "ai-rendering-library": "static-1.10498",
  "chirp-fetch": "static-1.1982",
  "connections-embed-lib": "static-1.1156",
  "copilot-toolkit": "static-1.11371",
  "feedback-loader": "static-1.29465",
  "laboratory-lib": "static-3.7250",
  "marketplace-embed": "static-1.22382",
  "marketplace-ui-details": "static-1.9982",
  "marketplace-ui-reviews": "static-1.20042",
  "marketplace-ui-tracking": "static-1.14257",
  "sanitize-text": "static-1.8240",
  "ui-addon-video-player": "static-1.8798",
  "usage-tracker-multi": "static-1.5856",
  "usage-tracker-session-replay": "static-1.5128",
  "wootric-nps": "static-1.7052",
  "quartz-head": "static-1.810",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4747",
  "immer": "static-1.33",
  "immerable": "static-1.4248",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67921",
  "cssUtils": "static-1.817",
  "flux-actions": "static-1.343",
  "HubStyle": "static-2.11876",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10302",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10457",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7432",
  "icons": "static-2.651",
  "marketplace-ui-apps-core": "static-1.18619",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4607",
  "foundations-components-test-utils": "static-1.5598",
  "quartz-i18n": "static-1.820",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.297",
  "google-sheets-integration-lib": "static-1.511",
  "microsoft-drive-integration-lib": "static-1.648",
  "slack-ui-library": "static-1.10489",
  "fsm": "static-1.3824",
  "customer-data-objects": "static-1.7772",
  "property-translator": "static-1.5491",
  "hs-locale-management": "static-1.150",
  "frontend-preferences-client": "static-1.8020",
  "hs-promise-utils": "static-1.5686",
  "hubspot-apollo-client": "static-1.4973",
  "integrations-error-boundary-lib": "static-1.13871",
  "integrations-tracking-lib": "static-1.5701",
  "native-integrations-shared-strings": "static-1.7877",
  "reselect": "static-2.16",
  "sanitize": "static-1.4572",
  "superstore": "static-1.4855",
  "ui-shepherd-react": "static-3.10316",
  "ai-settings-ui-library": "static-1.8034",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4720",
  "immutable-less": "static-1.4748",
  "marketplace-ui-client-types": "static-1.17494",
  "nav-meta": "static-1.29883",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18128",
  "inbound-db-properties-service-client": "static-1.3914",
  "property-management-common": "static-1.5766",
  "ui-addon-iframeable": "static-1.9158",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.820",
  "quartz-test": "static-1.820",
  "quartz-tracking": "static-1.524",
  "trellis-components": "static-1.2184",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.160",
  "bender-build-tools": "static-1.3278",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21739",
  "ContentUtils": "static-1.68625",
  "customer-data-objects-ui-components": "static-1.13125",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.304",
  "breeze-onboarding-components": "static-1.192",
  "avatar-components": "static-1.2592",
  "customer-data-filters-ui": "static-1.40115",
  "customer-data-reference-ui-components": "static-1.13264",
  "embedded-academy-lib": "static-1.14617",
  "ExportDialog": "static-6.10475",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41539",
  "reporting-snowflake": "static-1.56539",
  "reporting-ui-components": "static-2.65192",
  "reporting-visualizations": "static-1.59997",
  "ui-addon-teams": "static-1.21675",
  "integrations-reconnect-lib": "static-1.129",
  "magpie-lib": "static-1.5612",
  "navigation-components": "static-1.18246",
  "breeze-engine-lib": "static-1.1026",
  "magpie-types": "static-1.5072",
  "simple-logging-lib": "static-1.3145",
  "ai-studio-lib": "static-1.11884",
  "app-governance-lib": "static-1.1848",
  "developer-experience-shared-components": "static-1.10609",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8101",
  "ui-product-approvals": "static-1.28539",
  "ui-tool-access": "static-1.10243",
  "usage-based-billing-components-lib": "static-1.9346",
  "usage-tracker-anonymous": "static-1.5859",
  "usage-tracker-public": "static-1.7253",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3655",
  "persist-promise": "static-1.3793",
  "reference-resolvers": "static-1.8269",
  "ui-extensibility-client-types": "static-1.4019",
  "hubspot-apollo-cache": "static-1.432",
  "universal-page-editor-lib": "static-1.3112",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3041",
  "atom": "static-1.5169",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.6061",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1636",
  "crm-component-utils": "static-1.39321",
  "crm-properties-common-lib": "static-1.5983",
  "customer-data-properties": "static-1.51905",
  "framework-data-schema-resolvers": "static-1.6985",
  "property-value-citations": "static-1.2519",
  "reference-resolvers-lite": "static-1.8192",
  "ui-business-units-lib": "static-1.9156",
  "navigation-messaging": "static-1.7573",
  "hubspotter-http-shared-msw-handlers": "static-1.10187",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1035",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4908",
  "content-icons-ui": "static-1.2251",
  "customer-data-ui-utilities": "static-1.9920",
  "conversations-skeleton-state": "static-1.7344",
  "crm-message-bus": "static-1.43222",
  "customer-data-filters-ui-msw-helpers": "static-1.22550",
  "events-data-lib": "static-1.325",
  "FormUrlGenerator": "static-2.4816",
  "framework-builder-read-service-client": "static-1.4074",
  "framework-data-schema-quick-fetch": "static-1.6890",
  "multi-account-reference-resolvers": "static-1.1076",
  "onboarding-tours": "static-1.16773",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13945",
  "academy-common-lib": "static-1.14077",
  "content-assistance-lib": "static-1.7899",
  "dashboard-lib": "static-1.81892",
  "file-manager-components": "static-1.23855",
  "getting-started-shared-tasks": "static-1.18670",
  "hubspot-prosemirror": "static-1.18487",
  "hubspot-prosemirror-plugins": "static-1.18479",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19987",
  "share-with-third-party-component-lib": "static-1.8799",
  "ui-addon-draggable": "static-3.4856",
  "ui-asset-management-lib": "static-1.11156",
  "user-context": "static-1.5205",
  "growth-payments-core": "static-1.25651",
  "reporting-plugins": "static-1.10482",
  "reporting-reports": "static-1.67599",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.820",
  "nest": "static-1.327",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10723",
  "framework-listing-lib": "static-2.28953",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30937",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4346",
  "react-dnd-compat": "static-1.4709",
  "ui-product-approvals-common": "static-1.434",
  "onboarding-scopes": "static-1.6557",
  "onboarding-tours-client": "static-1.4987",
  "platform-infra-nav-components": "static-1.7741",
  "subscription-experience-data-types": "static-1.15047",
  "crm-record-cards-service-types": "static-1.3658",
  "location-customization-utils-lib": "static-1.9529",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6064",
  "signup-constants": "static-1.19057",
  "signup-ui-url-generator": "static-2.8152",
  "card-properties-lib": "static-1.44474",
  "commerce-subscription-lib": "static-1.37391",
  "crm-actions": "static-1.6433",
  "crm-cards-sdk": "static-1.43857",
  "customer-data-properties-shared-msw-handlers": "static-1.9516",
  "customer-data-tracking": "static-1.6985",
  "hs-resources": "static-1.270",
  "pulse": "static-1.690",
  "calling-global-api": "static-1.64832",
  "calling-internal-common": "static-1.31405",
  "calling-lifecycle-internal": "static-1.66214",
  "calling-lifecycle-messages": "static-1.58508",
  "commerce-products-lib": "static-1.9884",
  "conditional-properties-service-client": "static-1.3865",
  "crm-links": "static-1.6400",
  "crm-pipelines-api-client-types": "static-1.4207",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4289",
  "meetings-icalendar-utils-lib": "static-1.728",
  "multi-currency-client-types": "static-1.3759",
  "object-builder-ui-client": "static-1.49067",
  "pipeline-validation-client-types": "static-1.4035",
  "smart-property-lib": "static-1.7666",
  "tiered-pricing": "static-1.1429",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11084",
  "fdsr-migration-layer": "static-1.104",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1111",
  "growth-data-modal": "static-1.5576",
  "growth-onboarding-confetti": "static-1.3161",
  "growth-onboarding-next-action-utils": "static-1.2192",
  "onboarding-tours-utils": "static-1.839",
  "ui-shepherd-tracker": "static-1.7697",
  "academy-service-client": "static-1.3778",
  "SafeStorage": "static-1.4494",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39354",
  "FileManagerLib": "static-1.39495",
  "video-embed": "static-1.36069",
  "ui-coaching-tips": "static-1.28820",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11577",
  "video-data-lib": "static-1.35235",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8558",
  "payment-link-components": "static-1.23764",
  "ui-addon-emoji-picker": "static-1.9982",
  "EmailSignatureEditor": "static-1.24575",
  "viral-links-lib": "static-1.7164",
  "data-token-picker": "static-1.16566",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.319",
  "timezone-utils": "static-2.5338",
  "seat-types-lib": "static-1.231",
  "getting-started-shared-tasks-store": "static-1.17788",
  "ui-addon-opt": "static-4.8455",
  "campaign-roi-lib": "static-1.9363",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25638",
  "framework-data-table": "static-2.12124",
  "marketing-platform-lib": "static-1.6959",
  "nudge-client-utils": "static-1.2773",
  "nudge-custom-ui-functions": "static-1.1194",
  "switchboard-lib": "static-1.317",
  "app-users-service-client": "static-1.5702",
  "app-users-service-types": "static-1.5110",
  "mini-checkout-client": "static-1.27040",
  "onboarding-utils": "static-1.5454",
  "permissions-shared-i18n-strings-fe": "static-1.2059",
  "ui-coaching-tips-shared-config": "static-1.28805",
  "edison-service-client-types": "static-1.483",
  "crm_data": "static-4.92255",
  "customer-data-sidebar": "static-2.46270",
  "enrichment-properties-lib": "static-1.16784",
  "ui-addon-draggable-compat": "static-2.4354",
  "universal-record-utils-lib": "static-1.1179",
  "commerce-billing-lib": "static-1.19371",
  "commerce-shared-components-lib": "static-1.18750",
  "commerce-tools-ui-lib": "static-1.10617",
  "crm-fe-perf": "static-1.22998",
  "event-emitter": "static-1.1043",
  "bend-plugin-pulse": "static-1.193",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31412",
  "shared-worker-versioning": "static-1.11130",
  "calling-usage-tracker": "static-1.6638",
  "voice-sms-access-library": "static-1.1362",
  "commerce-permissions": "static-1.872",
  "products-iframe-lib": "static-1.8187",
  "products-ui-components-shared-msw-handlers": "static-1.10571",
  "data-agent-kit": "static-1.344",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10272",
  "policy-lib": "static-1.6875",
  "react-tinymce": "static-1.55489",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10335",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54615",
  "tinymce-plugins": "static-1.57729",
  "tinymce-themes": "static-1.56585",
  "onboarding-data-sync-lib": "static-1.2118",
  "growth-onboarding-next-action-components": "static-1.2220",
  "user-context-client": "static-1.4678",
  "audio-components": "static-1.6057",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37006",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4632",
  "video-components": "static-1.13579",
  "outpost": "static-1.4265",
  "growth-onboarding-feedback-components": "static-1.6674",
  "content-media-composition-data-lib": "static-1.12602",
  "content-media-compositions": "static-2.16609",
  "media-bridge-lib": "static-1.19083",
  "commerce-tours-lib": "static-1.6269",
  "growth-onboarding-reliability": "static-1.5176",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21834",
  "sales-email-signature-service-client": "static-1.3943",
  "ts-utils-lib": "static-1.267",
  "crm-export-dialog": "static-1.6380",
  "crm-index-associations-lib": "static-1.6539",
  "crm-view-components": "static-1.557",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7424",
  "nudge-custom-function-registry": "static-1.2530",
  "nudge-renderer-utils": "static-1.2849",
  "whisper-core-api": "static-1.6819",
  "InboxConnectUtils": "static-4.15056",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5751",
  "settings-content-modals": "static-1.46347",
  "crm_universal": "static-1.22166",
  "customer-data-email": "static-1.18194",
  "card-payment-highlight-lib": "static-1.37436",
  "card-subscription-highlight-lib": "static-1.39814",
  "commerce-contract-lib": "static-1.12528",
  "invoices-highlight-card-lib": "static-1.55014",
  "orders-highlight-card-lib": "static-1.21723",
  "products-highlight-card-lib": "static-1.18167",
  "quotes-highlight-card-lib": "static-1.72332",
  "crm-source-interpretation-lib": "static-1.5438",
  "crm-object-search-query-utilities": "static-1.9787",
  "utility-belt": "static-1.2628",
  "payments-enrollment-embed-lib": "static-1.23182",
  "stripe-embedded-components": "static-1.7669",
  "customer-data-rte": "static-1.33238",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5906",
  "payments-post-enroll-local-storage-lib": "static-1.5201",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38422",
  "trials-service-types": "static-1.3974",
  "calling-orchestration-schema": "static-1.36139",
  "sales-views-client-types": "static-1.4351",
  "hub-http-contrib": "static-1.3137",
  "interframe": "static-3.4855",
  "tinymce-data": "static-1.40700",
  "ui-addon-sales-email": "static-1.5304",
  "layout-dnd-components": "static-1.12619",
  "layout-dnd-utils": "static-1.11594",
  "ui-brand-identity-lib": "static-1.15608",
  "NamespacedHubStyle": "static-2.9127",
  "meetings-connect-utils-lib": "static-1.7699",
  "social-insights-client-types": "static-1.22301",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4257",
  "checkout-sdk": "static-3.23883",
  "checkout-service-types": "static-1.3869",
  "company-details-components": "static-1.6293",
  "payment-method-components": "static-1.6971",
  "pricing-pages-ui-components": "static-1.14601",
  "quote-checkout-service-types": "static-1.3559",
  "upgrade-catalog-service-types": "static-1.3615",
  "access-control-lib": "static-1.10528",
  "EmailComponents": "static-1.55022",
  "EmailData": "static-1.53699",
  "redux-less": "static-2.9578",
  "sequences-lib": "static-1.8201",
  "ui-gdpr-components": "static-1.10445",
  "products-ui-components": "static-1.40402",
  "accounting-integrations-ui-components": "static-1.7211",
  "invoices-ui-lib": "static-1.55030",
  "commerce-products-api": "static-1.2428",
  "invoices-iframe-lib": "static-1.57088",
  "quotes-modal-lib": "static-1.103010",
  "quotes-ui-lib": "static-1.81053",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28509",
  "ContentData": "static-1.68700",
  "layout-data-lib": "static-1.9919",
  "hub-http-rxjs": "static-1.807",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4032",
  "billing-payments-client-types": "static-1.4085",
  "react-performance-metrics-lib": "static-1.651",
  "account-and-billing-fintech-outages": "static-3.18701",
  "pricing-pages-api": "static-1.14466",
  "ContentComponents": "static-2.71581",
  "marketing-contacts-lib": "static-1.10361",
  "marketing-email-service-types": "static-1.1974",
  "messaging-editing-lib": "static-1.46531",
  "messaging-usage-based-billing-components-lib": "static-1.1393",
  "automation-ui-source-apps": "static-1.19151",
  "automation-ui-types": "static-1.20069",
  "messaging-types-lib": "static-1.46268",
  "onboarding-settings-client": "static-1.4598",
  "sequences-client-types-lib": "static-1.8058",
  "commerce-tax-lib": "static-1.631",
  "price-books-api": "static-1.1175",
  "price-books-components": "static-1.1233",
  "property-description-translator": "static-1.3935",
  "ramp-editor": "static-1.363",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23852",
  "SalesContentIndexUI": "static-3.9379",
  "advanced-menus-core": "static-1.15278",
  "advanced-menus-lib": "static-1.12193",
  "ui-memberships-settings-lib": "static-1.34295",
  "segments-query-core": "static-1.1513",
  "automation-ui-ubb": "static-1.5985",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7433",
  "data-token-views": "static-1.16547",
  "forms-utils-lib": "static-1.12754",
  "payments-embed-points-lib": "static-1.13222",
  "simple-menus-core": "static-1.15277",
  "simple-menus-lib": "static-1.16794",
  "videoconference-integration-components": "static-1.6951",
  "marketing-contacts-client": "static-1.7608",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2626",
  "ContentEditorUI": "static-2.77363",
  "short-messages-app-service-client": "static-1.4029",
  "web-interactives-components": "static-1.13918",
  "web-interactives-data": "static-1.13919",
  "messaging-shared-utils-lib": "static-1.842",
  "messaging-user-info-utils-lib": "static-1.1012",
  "email-portal-health-service-types": "static-1.1072",
  "line-items-api": "static-1.832",
  "commerce-totals-service-types": "static-1.3887",
  "FireAlarmUi": "static-1.4580",
  "sales-templates-service-types-lib": "static-1.4239",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22005",
  "automation-ui-usage-tracking": "static-1.21468",
  "data-studio-ubb": "static-1.2989",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27228",
  "collaboration-sidebar": "static-1.58100",
  "content-management-data-lib": "static-1.5554",
  "copilot-plugins": "static-1.11344",
  "cta-picker": "static-1.36646",
  "customer-agent-discovery-components-lib": "static-1.3347",
  "editor-components": "static-1.13359",
  "editor-iframe-lib": "static-1.8531",
  "error-messaging-js": "static-1.5286",
  "FormsCommonComponents": "static-1.86111",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10741",
  "SharedLegalStrings": "static-1.1839",
  "smart-content-core": "static-1.42692",
  "smart-content-lib": "static-1.43345",
  "social-composer-lib": "static-1.59492",
  "structured-content-lib": "static-1.25436",
  "theme-previewer-lib": "static-1.53494",
  "tinymce-copilot": "static-1.16683",
  "xray-recommendation-lib": "static-1.8031",
  "automation-ui-routing": "static-1.21426",
  "sql-reporting-client-types": "static-1.5716",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42391",
  "campaigns-utils-lib": "static-1.3283",
  "reporting-enablement": "static-1.23249",
  "chatspot-widget-iframe": "static-1.21730",
  "collaboration-sidebar-common": "static-1.2897",
  "forms-ai-lib": "static-1.4463",
  "codemirror-dlb": "static-1.58922",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6529",
  "report-customization-components": "static-1.13410",
  "data-quality-ui-library": "static-1.13274",
  "reporting-filters": "static-1.551",
  "reporting-insights-lib": "static-1.2016"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12630",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9756",
  "foundations-components": "/foundations-components/static-1.8115",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1140",
  "foundations-theming": "/foundations-theming/static-1.4527",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8113",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10189",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11569",
  "I18n": "/I18n/static-7.1634",
  "jasmine-runner": "/jasmine-runner/static-1.6555",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12693",
  "quartz": "/quartz/static-1.7145",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16777",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2953",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9854",
  "settings-ui-lib": "/settings-ui-lib/static-1.12615",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7308",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11245",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9634",
  "unified-auth": "/unified-auth/static-1.603",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.885",
  "usage-tracker": "/usage-tracker/static-1.7442",
  "usage-tracker-core": "/usage-tracker-core/static-1.7292",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8191",
  "hub-http": "/hub-http/static-1.6316",
  "integrations-lib": "/integrations-lib/static-1.16456",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20087",
  "property-management-iframe": "/property-management-iframe/static-1.13478",
  "quartz-config": "/quartz-config/static-1.923",
  "quartz-core": "/quartz-core/static-1.6364",
  "quartz-routing": "/quartz-routing/static-1.575",
  "quick-fetch": "/quick-fetch/static-1.3986",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4750",
  "ts-schema": "/ts-schema/static-1.4149",
  "ui-universal-auth": "/ui-universal-auth/static-1.9089",
  "UIComponents": "/UIComponents/static-3.8515",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3468",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3422",
  "quartz-webpack": "/quartz-webpack/static-1.3369",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.223",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4384",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4964",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2243",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9516",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5411",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2165",
  "ui-fonts": "/ui-fonts/static-1.831",
  "ui-images": "/ui-images/static-2.1175",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3010",
  "foundations-theming-base": "/foundations-theming-base/static-1.3512",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.766",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3224",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4421",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9187",
  "ai-rendering-library": "/ai-rendering-library/static-1.10498",
  "chirp-fetch": "/chirp-fetch/static-1.1982",
  "connections-embed-lib": "/connections-embed-lib/static-1.1156",
  "copilot-toolkit": "/copilot-toolkit/static-1.11371",
  "feedback-loader": "/feedback-loader/static-1.29465",
  "laboratory-lib": "/laboratory-lib/static-3.7250",
  "marketplace-embed": "/marketplace-embed/static-1.22382",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9982",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20042",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14257",
  "sanitize-text": "/sanitize-text/static-1.8240",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8798",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5856",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5128",
  "wootric-nps": "/wootric-nps/static-1.7052",
  "quartz-head": "/quartz-head/static-1.810",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4747",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4248",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67921",
  "cssUtils": "/cssUtils/static-1.817",
  "flux-actions": "/flux-actions/static-1.343",
  "HubStyle": "/HubStyle/static-2.11876",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10302",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10457",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7432",
  "icons": "/icons/static-2.651",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18619",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4607",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5598",
  "quartz-i18n": "/quartz-i18n/static-1.820",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.297",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.511",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.648",
  "slack-ui-library": "/slack-ui-library/static-1.10489",
  "fsm": "/fsm/static-1.3824",
  "customer-data-objects": "/customer-data-objects/static-1.7772",
  "property-translator": "/property-translator/static-1.5491",
  "hs-locale-management": "/hs-locale-management/static-1.150",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8020",
  "hs-promise-utils": "/hs-promise-utils/static-1.5686",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4973",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13871",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5701",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7877",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4572",
  "superstore": "/superstore/static-1.4855",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10316",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8034",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4720",
  "immutable-less": "/immutable-less/static-1.4748",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17494",
  "nav-meta": "/nav-meta/static-1.29883",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18128",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3914",
  "property-management-common": "/property-management-common/static-1.5766",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9158",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.820",
  "quartz-test": "/quartz-test/static-1.820",
  "quartz-tracking": "/quartz-tracking/static-1.524",
  "trellis-components": "/trellis-components/static-1.2184",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.160",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21739",
  "ContentUtils": "/ContentUtils/static-1.68625",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13125",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.304",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.192",
  "avatar-components": "/avatar-components/static-1.2592",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40115",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13264",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14617",
  "ExportDialog": "/ExportDialog/static-6.10475",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41539",
  "reporting-snowflake": "/reporting-snowflake/static-1.56539",
  "reporting-ui-components": "/reporting-ui-components/static-2.65192",
  "reporting-visualizations": "/reporting-visualizations/static-1.59997",
  "ui-addon-teams": "/ui-addon-teams/static-1.21675",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.129",
  "magpie-lib": "/magpie-lib/static-1.5612",
  "navigation-components": "/navigation-components/static-1.18246",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1026",
  "magpie-types": "/magpie-types/static-1.5072",
  "simple-logging-lib": "/simple-logging-lib/static-1.3145",
  "ai-studio-lib": "/ai-studio-lib/static-1.11884",
  "app-governance-lib": "/app-governance-lib/static-1.1848",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10609",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8101",
  "ui-product-approvals": "/ui-product-approvals/static-1.28539",
  "ui-tool-access": "/ui-tool-access/static-1.10243",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9346",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5859",
  "usage-tracker-public": "/usage-tracker-public/static-1.7253",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3655",
  "persist-promise": "/persist-promise/static-1.3793",
  "reference-resolvers": "/reference-resolvers/static-1.8269",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4019",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.432",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3112",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3041",
  "atom": "/atom/static-1.5169",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.6061",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1636",
  "crm-component-utils": "/crm-component-utils/static-1.39321",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5983",
  "customer-data-properties": "/customer-data-properties/static-1.51905",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6985",
  "property-value-citations": "/property-value-citations/static-1.2519",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8192",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9156",
  "navigation-messaging": "/navigation-messaging/static-1.7573",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10187",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1035",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4908",
  "content-icons-ui": "/content-icons-ui/static-1.2251",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9920",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7344",
  "crm-message-bus": "/crm-message-bus/static-1.43222",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22550",
  "events-data-lib": "/events-data-lib/static-1.325",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4816",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4074",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6890",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1076",
  "onboarding-tours": "/onboarding-tours/static-1.16773",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13945",
  "academy-common-lib": "/academy-common-lib/static-1.14077",
  "content-assistance-lib": "/content-assistance-lib/static-1.7899",
  "dashboard-lib": "/dashboard-lib/static-1.81892",
  "file-manager-components": "/file-manager-components/static-1.23855",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18670",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18487",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18479",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19987",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8799",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4856",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11156",
  "user-context": "/user-context/static-1.5205",
  "growth-payments-core": "/growth-payments-core/static-1.25651",
  "reporting-plugins": "/reporting-plugins/static-1.10482",
  "reporting-reports": "/reporting-reports/static-1.67599",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.820",
  "nest": "/nest/static-1.327",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10723",
  "framework-listing-lib": "/framework-listing-lib/static-2.28953",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30937",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4346",
  "react-dnd-compat": "/react-dnd-compat/static-1.4709",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.434",
  "onboarding-scopes": "/onboarding-scopes/static-1.6557",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4987",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7741",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15047",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3658",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9529",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6064",
  "signup-constants": "/signup-constants/static-1.19057",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8152",
  "card-properties-lib": "/card-properties-lib/static-1.44474",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37391",
  "crm-actions": "/crm-actions/static-1.6433",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43857",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9516",
  "customer-data-tracking": "/customer-data-tracking/static-1.6985",
  "hs-resources": "/hs-resources/static-1.270",
  "pulse": "/pulse/static-1.690",
  "calling-global-api": "/calling-global-api/static-1.64832",
  "calling-internal-common": "/calling-internal-common/static-1.31405",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66214",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58508",
  "commerce-products-lib": "/commerce-products-lib/static-1.9884",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3865",
  "crm-links": "/crm-links/static-1.6400",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4207",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4289",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.728",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3759",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49067",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4035",
  "smart-property-lib": "/smart-property-lib/static-1.7666",
  "tiered-pricing": "/tiered-pricing/static-1.1429",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11084",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.104",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1111",
  "growth-data-modal": "/growth-data-modal/static-1.5576",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3161",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2192",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.839",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7697",
  "academy-service-client": "/academy-service-client/static-1.3778",
  "SafeStorage": "/SafeStorage/static-1.4494",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39354",
  "FileManagerLib": "/FileManagerLib/static-1.39495",
  "video-embed": "/video-embed/static-1.36069",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28820",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11577",
  "video-data-lib": "/video-data-lib/static-1.35235",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8558",
  "payment-link-components": "/payment-link-components/static-1.23764",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9982",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24575",
  "viral-links-lib": "/viral-links-lib/static-1.7164",
  "data-token-picker": "/data-token-picker/static-1.16566",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.319",
  "timezone-utils": "/timezone-utils/static-2.5338",
  "seat-types-lib": "/seat-types-lib/static-1.231",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17788",
  "ui-addon-opt": "/ui-addon-opt/static-4.8455",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9363",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25638",
  "framework-data-table": "/framework-data-table/static-2.12124",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6959",
  "nudge-client-utils": "/nudge-client-utils/static-1.2773",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1194",
  "switchboard-lib": "/switchboard-lib/static-1.317",
  "app-users-service-client": "/app-users-service-client/static-1.5702",
  "app-users-service-types": "/app-users-service-types/static-1.5110",
  "mini-checkout-client": "/mini-checkout-client/static-1.27040",
  "onboarding-utils": "/onboarding-utils/static-1.5454",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2059",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28805",
  "edison-service-client-types": "/edison-service-client-types/static-1.483",
  "crm_data": "/crm_data/static-4.92255",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46270",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16784",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4354",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1179",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19371",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18750",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10617",
  "crm-fe-perf": "/crm-fe-perf/static-1.22998",
  "event-emitter": "/event-emitter/static-1.1043",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.193",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31412",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11130",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6638",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1362",
  "commerce-permissions": "/commerce-permissions/static-1.872",
  "products-iframe-lib": "/products-iframe-lib/static-1.8187",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10571",
  "data-agent-kit": "/data-agent-kit/static-1.344",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10272",
  "policy-lib": "/policy-lib/static-1.6875",
  "react-tinymce": "/react-tinymce/static-1.55489",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10335",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54615",
  "tinymce-plugins": "/tinymce-plugins/static-1.57729",
  "tinymce-themes": "/tinymce-themes/static-1.56585",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2118",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2220",
  "user-context-client": "/user-context-client/static-1.4678",
  "audio-components": "/audio-components/static-1.6057",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37006",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4632",
  "video-components": "/video-components/static-1.13579",
  "outpost": "/outpost/static-1.4265",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6674",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12602",
  "content-media-compositions": "/content-media-compositions/static-2.16609",
  "media-bridge-lib": "/media-bridge-lib/static-1.19083",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6269",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5176",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21834",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3943",
  "ts-utils-lib": "/ts-utils-lib/static-1.267",
  "crm-export-dialog": "/crm-export-dialog/static-1.6380",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6539",
  "crm-view-components": "/crm-view-components/static-1.557",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7424",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2530",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2849",
  "whisper-core-api": "/whisper-core-api/static-1.6819",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15056",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5751",
  "settings-content-modals": "/settings-content-modals/static-1.46347",
  "crm_universal": "/crm_universal/static-1.22166",
  "customer-data-email": "/customer-data-email/static-1.18194",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37436",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39814",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12528",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55014",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21723",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18167",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72332",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5438",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9787",
  "utility-belt": "/utility-belt/static-1.2628",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23182",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7669",
  "customer-data-rte": "/customer-data-rte/static-1.33238",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5906",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5201",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38422",
  "trials-service-types": "/trials-service-types/static-1.3974",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36139",
  "sales-views-client-types": "/sales-views-client-types/static-1.4351",
  "hub-http-contrib": "/hub-http-contrib/static-1.3137",
  "interframe": "/interframe/static-3.4855",
  "tinymce-data": "/tinymce-data/static-1.40700",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5304",
  "layout-dnd-components": "/layout-dnd-components/static-1.12619",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11594",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15608",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9127",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7699",
  "social-insights-client-types": "/social-insights-client-types/static-1.22301",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4257",
  "checkout-sdk": "/checkout-sdk/static-3.23883",
  "checkout-service-types": "/checkout-service-types/static-1.3869",
  "company-details-components": "/company-details-components/static-1.6293",
  "payment-method-components": "/payment-method-components/static-1.6971",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14601",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3559",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3615",
  "access-control-lib": "/access-control-lib/static-1.10528",
  "EmailComponents": "/EmailComponents/static-1.55022",
  "EmailData": "/EmailData/static-1.53699",
  "redux-less": "/redux-less/static-2.9578",
  "sequences-lib": "/sequences-lib/static-1.8201",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10445",
  "products-ui-components": "/products-ui-components/static-1.40402",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7211",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55030",
  "commerce-products-api": "/commerce-products-api/static-1.2428",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57088",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103010",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81053",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28509",
  "ContentData": "/ContentData/static-1.68700",
  "layout-data-lib": "/layout-data-lib/static-1.9919",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.807",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4032",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4085",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.651",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18701",
  "pricing-pages-api": "/pricing-pages-api/static-1.14466",
  "ContentComponents": "/ContentComponents/static-2.71581",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10361",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1974",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46531",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1393",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19151",
  "automation-ui-types": "/automation-ui-types/static-1.20069",
  "messaging-types-lib": "/messaging-types-lib/static-1.46268",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4598",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8058",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.631",
  "price-books-api": "/price-books-api/static-1.1175",
  "price-books-components": "/price-books-components/static-1.1233",
  "property-description-translator": "/property-description-translator/static-1.3935",
  "ramp-editor": "/ramp-editor/static-1.363",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23852",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9379",
  "advanced-menus-core": "/advanced-menus-core/static-1.15278",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12193",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34295",
  "segments-query-core": "/segments-query-core/static-1.1513",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5985",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7433",
  "data-token-views": "/data-token-views/static-1.16547",
  "forms-utils-lib": "/forms-utils-lib/static-1.12754",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13222",
  "simple-menus-core": "/simple-menus-core/static-1.15277",
  "simple-menus-lib": "/simple-menus-lib/static-1.16794",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6951",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7608",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2626",
  "ContentEditorUI": "/ContentEditorUI/static-2.77363",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4029",
  "web-interactives-components": "/web-interactives-components/static-1.13918",
  "web-interactives-data": "/web-interactives-data/static-1.13919",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.842",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1012",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1072",
  "line-items-api": "/line-items-api/static-1.832",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3887",
  "FireAlarmUi": "/FireAlarmUi/static-1.4580",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4239",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22005",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21468",
  "data-studio-ubb": "/data-studio-ubb/static-1.2989",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27228",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58100",
  "content-management-data-lib": "/content-management-data-lib/static-1.5554",
  "copilot-plugins": "/copilot-plugins/static-1.11344",
  "cta-picker": "/cta-picker/static-1.36646",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3347",
  "editor-components": "/editor-components/static-1.13359",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8531",
  "error-messaging-js": "/error-messaging-js/static-1.5286",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10741",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1839",
  "smart-content-core": "/smart-content-core/static-1.42692",
  "smart-content-lib": "/smart-content-lib/static-1.43345",
  "social-composer-lib": "/social-composer-lib/static-1.59492",
  "structured-content-lib": "/structured-content-lib/static-1.25436",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53494",
  "tinymce-copilot": "/tinymce-copilot/static-1.16683",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8031",
  "automation-ui-routing": "/automation-ui-routing/static-1.21426",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5716",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42391",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3283",
  "reporting-enablement": "/reporting-enablement/static-1.23249",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21730",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2897",
  "forms-ai-lib": "/forms-ai-lib/static-1.4463",
  "codemirror-dlb": "/codemirror-dlb/static-1.58922",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6529",
  "report-customization-components": "/report-customization-components/static-1.13410",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13274",
  "reporting-filters": "/reporting-filters/static-1.551",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2016"
}
};
